import { RouterProvider } from '@tanstack/react-router';
import { Toaster } from '@ignite/ui';
import { router } from './routes';

export function App() {
  return (
    <>
      <RouterProvider router={router} />
      <Toaster />
    </>
  );
}
